import React, {Component} from 'react';
import decl from '../helpers/declension';
import FooterIcon from './icon';
import PropTypes from "prop-types";

class Footer extends Component {
  static propTypes = {
    selected: PropTypes.array,
    session: PropTypes.object,
    checkout: PropTypes.object,
    amount: PropTypes.number,
  };

  /**
   * Конструктор класса
   * @param props
   */
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
    };
  }

  /**
   * Метод для определения каким будет след шаг
   * @returns {Promise<void>}
   */
  nextStep = async () => {
    this.setState({
      loading: true,
    });

    await this.props.nextStepAfterSchema();

    await this.setState({
      loading: false,
    });
  };


  /**
   * Рендерим html
   * @returns {JSX.Element}
   */
  render() {
    const {loading} = this.state;
    const {selected, session, checkout, amount, user} = this.props;

    const btnClasses = ['btn', 'btn--accent'];
    if (loading) btnClasses.push('btn--loading');
    btnClasses.push('btn--disable');

    const choosedTicketClasses = ['hint__tickets'];
    if (selected.length > 0) {
      choosedTicketClasses.push('hint__tickets--active');
      btnClasses.pop();
    }

    const choosedTicketTexg =
      selected.length > 0
        ? `${selected.length} ${decl(selected.length, [
          'билет',
          'билета',
          'билетов',
        ])} за ${parseInt(amount - checkout.bonusPay)} руб.`
        : `Выберите места`;

    if (session.disabled) return null;

    return (
      <div className="scheme-popup__content">
        <div className="checkout">
          <div/>
          <div className="checkout-result">
            <FooterIcon
              user={user}
              cinema={session.cinema}
              onLogin={() => this.props.onLogin()}
            />

            <div className="checkout-result__wrapper">
              <button
                className={choosedTicketClasses.join(' ')}
                onClick={() => this.props.showTooltip()}
              >
                {choosedTicketTexg}
              </button>
              <div className="wrap">
                <button
                  className={btnClasses.join(' ')}
                  onClick={async () => {
                    if (typeof window !== 'undefined') {
                      window.ym?.(51446455, 'reachGoal', 'buy_button');
                    }
                    await this.nextStep();
                  }}
                  type="button"
                >
                  Купить билеты
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
}

export default Footer;
